<template>
  <div>
    <v-container fluid>
      <v-card class="card2" style="margin-top: 1rem">
        <v-card-text>
          <v-row align="center">
            <v-col cols="12" md="6">
              <h1 style="font-weight: 600; font-size: 28px;" class="mr-4">Model Grouping</h1>
            </v-col>
            <v-col cols="12" md="6" class="d-flex flex-wrap justify-end gap-2">
              <!-- <v-card variant="outlined" class="pa-2 search-panel">
                <v-row no-gutters>
                  <v-col cols="9" class="pa-2">
                    <v-text-field
                      id="modelgroup-field-search-setupgroupmodel"
                      :label="$t('Model Group')"
                      density="comfortable"
                      variant="outlined"
                      prepend-inner-icon="mdi-clipboard-text-search-outline"
                      hide-details
                      clearable
                      v-model="searchName"
                      @keydown.enter="Search"
                      color="primary"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3" class="pa-2 d-flex align-center justify-end">
                    <v-btn
                      color="primary"
                      class="ml-2"
                      variant="elevated"
                      prepend-icon="mdi-magnify"
                      @click="Search"
                    >
                      {{  $t("search") }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card> -->
              <div class="custom-search-input-wrapper">
                    <div class="custom-search-input-container">
                      <v-icon class="custom-search-input-icon">mdi-magnify</v-icon>
                      <input id="modelgroup-field-search-setupgroupmodel" type="text" placeholder="Model Group Name"
                        class="custom-search-input" v-model="searchName" @keydown.enter="Search" />
                      <v-icon class="clear-icon" :style="searchName ? '' : 'color: transparent !important;'"
                        @click="searchName = ''">
                        mdi-close-circle
                      </v-icon>
                    </div>
                  </div>
              <v-btn
                id="button-add-validationnegative"
                class="control-btn create-btn customadd"
                variant="flat"
                size="large"
                prepend-icon="mdi-plus"
                rounded="xl"
                @click="Add()"
              >
                {{ $t("add") }}
                <v-tooltip activator="parent" location="top">Add Model Group</v-tooltip>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
        <v-data-table-server
          :items-per-page="options.itemsPerPage"
          :items-length="searchTotalTable"
          v-model:options="options"
          :items="menus"
          :headers="headers"
          :footer-props="{
          'items-per-page-options': [
            { value: 10, title: '10' },
            { value: 25, title: '25' },
            { value: 50, title: '50' },
            { value: 100, title: '100' },
            { value: -1, title: 'All' }
          ],
        }"
          :loading="loadingTable"
          class="pa-5"
        >
          <template v-slot:item="{ item,index }">
            <tr>
              <td style="text-align: center">{{ (options.page - 1) * options.itemsPerPage + index + 1 }}</td>
              <td>{{ item.name }}</td>
              <td style="text-align: start">
                <div class="model-chips-container">
              <!-- Show first 2 model chips -->
              <template v-if="item.modelNameTable && item.modelNameTable !== '' && item.modelNameTable !== 'All Model'">
                <v-chip
                  v-for="(model, idx) in getModelChips(item.modelNameTable).slice(0, 2)"
                  :key="idx"
                  size="small"
                  variant="tonal"
                  class="model-chip-item"
                >
                  {{ model }}
                </v-chip>
                
                <!-- Show remaining count chip -->
                <v-chip
                  v-if="getModelChips(item.modelNameTable).length > 2"
                  size="small"
                  class="model-chip-count"
                >
                  +{{ getModelChips(item.modelNameTable).length - 2 }}
                </v-chip>
              </template>
              
              <!-- Show "All Model" chip -->
              <v-chip
                v-else-if="item.modelNameTable === 'All Model'"
                size="small"
                variant="tonal"
                class="model-chip-item"
              >
                All Model
              </v-chip>
              
              <!-- Show dash for empty -->
              <span v-else class="text-grey">-</span>
            </div>
              </td>
              <td style="text-align: center">
                <div class="action-group" style="justify-content: center;">
                  <!-- View Details -->
                   <v-btn
                    icon
                    variant="text"
                    density="comfortable"
                    v-show="item.modelNameTable != 'All Model' && item.modelNameTable != ''"
                    @click="Detail(item)"
                      class="detail-btn"
                  >
                    <v-img :src="images.viewdetailImg" width="23" height="23"></v-img>
                      <v-tooltip activator="parent" location="top">
                        View Details
                      </v-tooltip>
                  </v-btn>
                  <!-- Edit -->
                  <v-btn
                    id="button-edit-popupedit-setupgroupmodel"
                    variant="text"
                    density="comfortable"
                    @click="Edit(item)"
                    class="action-btn edit-btn"
                    icon
                  >
                    <v-img :src="images.editBtn" width="23" height="23"></v-img>
                    <v-tooltip activator="parent" location="top">
                      Edit
                    </v-tooltip>
                  </v-btn>           
                  <!-- Delete -->
                  <v-btn
                    id="button-delete-setupgroupmodel"
                    variant="text"
                    density="comfortable"
                    @click="DeleteGroup(item.groupID)"
                    class="action-btn delete-btn"
                    icon
                  >
                    <v-img :src="images.deleteBtn" width="23" height="23"></v-img>
                    <v-tooltip activator="parent" location="top">
                      Delete
                    </v-tooltip>
                  </v-btn>
                </div>
              </td>
            </tr>
          </template>
           <!-- 👇 Custom footer area -->
          <template v-slot:bottom>
            <div
              class="d-flex justify-space-between align-center px-4 py-2"
              style="width: 100%"
            >
              <div>Total results {{ searchTotalTable }}</div>

              <v-data-table-footer
                v-model:items-per-page="itemsPerPage"
                :page="options.page"
                :length="Math.ceil(searchTotalTable / itemsPerPage)"
              />
            </div>
          </template>
        </v-data-table-server>
      </v-card>
    </v-container>
    <!-- Loading Please Wait... -->
    <v-overlay :model-value="dialog" class="align-center justify-center" persistent>
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular
            indeterminate
            size="64"
            color="primary"
            class="mb-4"
          ></v-progress-circular>
          <h3 class="loading-title">Loading...</h3>
          <p class="loading-subtitle">Please wait</p>
        </v-card-text>
      </v-card>
    </v-overlay>
    <!-- Edit -->

    <!-- Edit Dialog -->
    <v-dialog v-model="Editdialog" max-width="700px" persistent class="modern-dialog">
      <v-card class="dialog-card">
        <!-- Header -->
        <div class="dialog-header dialog-header-edit">
          <div class="header-main">
              <div class="header-icon-container">
                <div class="icon-background renew-mode">
                    <v-icon size="28" color="white">mdi-pencil</v-icon>
                </div>
              </div>
              <div class="header-text-content">
                <h2 class="dialog-title">{{ $t("Edit Model Group") }}</h2>
                <p class="dialog-subtitle">Modify model group configuration</p>
              </div>
            </div>
            <div class="header-actions">
              <v-btn
                icon
                variant="text"
                @click="Editdialog = false"
                class="close-button"
              >
                <v-icon color="white">mdi-close</v-icon>
              </v-btn>
            </div>
        </div>

        <!-- Content -->
        <v-card-text class="dialog-content">
          <div class="form-container">
            <!-- Model Group Name Section -->
            <div class="form-section">
              <div class="section-header">
                <v-icon size="20" color="primary" class="mr-2">mdi-folder-outline</v-icon>
                <h3 class="section-title">Basic Information</h3>
              </div>
              
              <div class="input-wrapper">
                <div class="input-label">
                  <span>{{ $t("groupModelName") }}</span>
                  <span class="required-asterisk">*</span>
                  <v-tooltip location="top" max-width="300px">
                    <template v-slot:activator="{ props }">
                      <v-icon
                        size="small"
                        v-bind="props"
                        color="grey-darken-1"
                        class="help-icon"
                      >
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span>{{ $t("_InfoGroupModelName") }}</span>
                  </v-tooltip>
                </div>
                
                <v-text-field
                  id="modelgroupname-field-popupedit-setupgroupmodel"
                  v-model="GroupModel.Name"
                  :rules="[rules.required]"
                  variant="outlined"
                  density="comfortable"
                  placeholder="Enter group name..."
                  hide-details="auto"
                  class="modern-input"
                />
              </div>
            </div>

            <!-- Model Configuration Section -->
            <div class="form-section">
              <div class="section-header">
                <v-icon size="20" color="primary" class="mr-2">mdi-robot-outline</v-icon>
                <h3 class="section-title">Model Configuration</h3>
              </div>

              <!-- All Model Checkbox -->
              <div class="checkbox-wrapper">
                <v-checkbox
                  id="allmodel-checkbox-popupedit-setupgroupmodel"
                  v-model="GroupModel.isAllModel"
                  color="primary"
                  hide-details
                  @click="clearModel()"
                  density="comfortable"
                  class="modern-checkbox"
                >
                  <template v-slot:label>
                    <div class="checkbox-label">
                      <span>All Model</span>
                      <v-tooltip location="top" max-width="300px">
                        <template v-slot:activator="{ props }">
                          <v-icon
                            size="small"
                            v-bind="props"
                            color="grey-darken-1"
                            class="help-icon ml-2"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <span>{{ $t("_InfoAllModel") }}</span>
                      </v-tooltip>
                    </div>
                  </template>
                </v-checkbox>
              </div>

              <!-- Model Selection -->
              <div class="input-wrapper" :class="{ 'disabled-section': GroupModel.isAllModel }">
                <div class="input-label">
                  <span>{{ $t("modelName") }}</span>
                  <v-tooltip location="top" max-width="300px">
                    <template v-slot:activator="{ props }">
                      <v-icon
                        size="small"
                        v-bind="props"
                        color="grey-darken-1"
                        class="help-icon"
                      >
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span>{{ $t("_InfoModelinGroup") }}</span>
                  </v-tooltip>
                </div>
                
                <v-autocomplete
                  id="modelname-autocomplete-popupedit-setupgroupmodel"
                  :disabled="GroupModel.isAllModel"
                  v-model="GroupModel.Model"
                  :items="DDGPTModel"
                  item-title="name"
                  item-value="modelDisplayID"
                  chips
                  clearable
                  closable-chips
                  multiple
                  variant="outlined"
                  density="comfortable"
                  hide-details="auto"
                  class="modern-autocomplete"
                  placeholder="Select models..."
                  prepend-inner-icon="mdi-magnify"
                >
                  <template v-slot:chip="{ props, item }">
                    <v-chip
                      v-bind="props"
                      :text="item.raw.name"
                      color="primary"
                      variant="tonal"
                      size="small"
                      closable
                      class="model-chip"
                    >
                      <template v-slot:prepend>
                        <v-icon size="16">mdi-robot</v-icon>
                      </template>
                    </v-chip>
                  </template>
                  
                  <template v-slot:item="{ props, item, index }">
                    <v-list-item v-bind="props" 
                      :id="'modelname-edit-setupgroupmodel-option-' + index" 
                      :value="item.raw.name"
                      class="autocomplete-item"
                    >
                      <template v-slot:prepend>
                        <v-avatar size="32" color="primary" variant="tonal">
                          <v-icon size="18">mdi-robot</v-icon>
                        </v-avatar>
                      </template>
                    </v-list-item>
                  </template>
                </v-autocomplete>
              </div>

              <!-- Info Message -->
              <div v-if="GroupModel.isAllModel" class="info-message">
                <v-icon size="16" color="info" class="mr-2">mdi-information-outline</v-icon>
                <span>All available models will be included in this group</span>
              </div>
            </div>
          </div>
        </v-card-text>

        <!-- Actions -->
        <v-card-actions class="dialog-actions">
          <div class="actions-content">
            <div class="actions-left">
              <v-chip
                v-if="GroupModel.Model && GroupModel.Model.length > 0"
                size="small"
                variant="tonal"
                color="info"
                class="summary-chip"
              >
                <v-icon size="14" class="mr-1">mdi-robot</v-icon>
                <span v-if="GroupModel.isAllModel">All models included</span>
                <span v-else>{{ GroupModel.Model.length }} models selected</span>
              </v-chip>
            </div>
            
            <div class="actions-right">
              <v-btn
                variant="outlined"
                color="grey"
                @click="Editdialog = false"
                class="dialog-action-btn cancel-btn"
              >
                <v-icon class="mr-2">mdi-close</v-icon>
                {{ $t("close") }}
              </v-btn>

              <v-btn
                id="button-save-popupedit-setupgroupmodel"
                variant="elevated"
                @click="Save()"
                class="dialog-action-btn save-btn-edit"
                :loading="dialog"
              >
                <v-icon class="mr-2">mdi-content-save</v-icon>
                {{ $t("save") }}
              </v-btn>
            </div>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Add Dialog -->
    <v-dialog v-model="Adddialog" max-width="700px" persistent class="modern-dialog">
      <v-card class="dialog-card">
        <!-- Header -->
        <div class="dialog-header dialog-header-add">
          <div class="header-main">
            <div class="header-text-content">
              <h2 class="dialog-title">{{ $t("Add Model Group") }}</h2>
              <p class="dialog-subtitle">Create a new model group configuration</p>
            </div>
          </div>
          <div class="header-actions">
            <v-btn
                icon
                variant="text"
                @click="Adddialog = false"
                class="close-button"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
          </div>
        </div>
        
        <!-- Content -->
        <v-card-text class="dialog-content">
          <div class="form-container">
            <!-- Model Group Name Section -->
            <div class="form-section">
              <div class="section-header">
                <v-icon size="20" color="primary" class="mr-2">mdi-folder-outline</v-icon>
                <h3 class="section-title">Basic Information</h3>
              </div>
              
              <div class="input-wrapper">
                <div class="input-label">
                  <span>{{ $t("Model Group Name") }}</span>
                  <span class="required-asterisk">*</span>
                  <v-tooltip location="top" max-width="300px">
                    <template v-slot:activator="{ props }">
                      <v-icon
                        size="small"
                        v-bind="props"
                        color="grey-darken-1"
                        class="help-icon"
                      >
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span>{{ $t("_InfoGroupModelName") }}</span>
                  </v-tooltip>
                </div>
                
                <v-text-field
                  id="modelgroupname-field-popupadd-setupgroupmodel"
                  v-model="GroupModel.Name"
                  :rules="[rules.required]"
                  variant="outlined"
                  density="comfortable"
                  placeholder="Enter group name..."
                  hide-details="auto"
                  class="modern-input"
                />
              </div>
            </div>

            <!-- Model Configuration Section -->
            <div class="form-section">
              <div class="section-header">
                <v-icon size="20" color="primary" class="mr-2">mdi-robot-outline</v-icon>
                <h3 class="section-title">Model Configuration</h3>
              </div>

              <!-- All Model Checkbox -->
              <div class="checkbox-wrapper">
                <v-checkbox
                  id="allmodel-checkbox-popupadd-setupgroupmodel"
                  v-model="GroupModel.isAllModel"
                  color="primary"
                  hide-details
                  @click="clearModel()"
                  density="comfortable"
                  class="modern-checkbox"
                >
                  <template v-slot:label>
                    <div class="checkbox-label">
                      <span>All Model</span>
                      <v-tooltip location="top" max-width="300px">
                        <template v-slot:activator="{ props }">
                          <v-icon
                            size="small"
                            v-bind="props"
                            color="grey-darken-1"
                            class="help-icon ml-2"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <span>{{ $t("_InfoAllModel") }}</span>
                      </v-tooltip>
                    </div>
                  </template>
                </v-checkbox>
              </div>

              <!-- Model Selection -->
              <div class="input-wrapper" :class="{ 'disabled-section': GroupModel.isAllModel }">
                <div class="input-label">
                  <span>{{ $t("Model Name") }}</span>
                  <span v-if="!GroupModel.isAllModel" class="required-asterisk">*</span>
                  <v-tooltip location="top" max-width="300px">
                    <template v-slot:activator="{ props }">
                      <v-icon
                        size="small"
                        v-bind="props"
                        color="grey-darken-1"
                        class="help-icon"
                      >
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span>{{ $t("_InfoModelinGroup") }}</span>
                  </v-tooltip>
                </div>
                
                <v-autocomplete
                  id="modelname-autocomplete-popupadd-setupgroupmodel"
                  :disabled="GroupModel.isAllModel"
                  v-model="GroupModel.Model"
                  :items="DDGPTModel"
                  item-title="name"
                  item-value="modelDisplayID"
                  chips
                  clearable
                  closable-chips
                  multiple
                  variant="outlined"
                  density="comfortable"
                  :rules="GroupModel.isAllModel ? [] : [rules.required]"
                  hide-details="auto"
                  class="modern-autocomplete"
                  placeholder="Select models..."
                  prepend-inner-icon="mdi-magnify"
                >
                  <template v-slot:chip="{ props, item }">
                    <v-chip
                      v-bind="props"
                      :text="item.raw.name"
                      color="primary"
                      variant="tonal"
                      size="small"
                      closable
                      class="model-chip"
                    >
                      <template v-slot:prepend>
                        <v-icon size="16">mdi-robot</v-icon>
                      </template>
                    </v-chip>
                  </template>
                  
                  <template v-slot:item="{ props, item, index }">
                    <v-list-item v-bind="props" 
                      :id="'modelname-add-setupgroupmodel-option-' + index"
                      :value="item.raw.name"
                      class="autocomplete-item"
                    >
                      <template v-slot:prepend>
                        <v-avatar size="32" color="primary" variant="tonal">
                          <v-icon size="18">mdi-robot</v-icon>
                        </v-avatar>
                      </template>
                    </v-list-item>
                  </template>
                </v-autocomplete>
              </div>

              <!-- Info Message -->
              <div v-if="GroupModel.isAllModel" class="info-message">
                <v-icon size="16" color="info" class="mr-2">mdi-information-outline</v-icon>
                <span>All available models will be included in this group</span>
              </div>
            </div>
          </div>
        </v-card-text>

        <!-- Actions -->
        <v-card-actions class="dialog-actions">
          <div class="actions-content">
            <div class="actions-left">
              <v-chip
                v-if="GroupModel.Model && GroupModel.Model.length > 0"
                size="small"
                variant="tonal"
                color="info"
                class="summary-chip"
              >
                <v-icon size="14" class="mr-1">mdi-robot</v-icon>
                <span v-if="GroupModel.isAllModel">All models included</span>
                <span v-else>{{ GroupModel.Model.length }} models selected</span>
              </v-chip>
            </div>
            
            <div class="actions-right">
              <v-btn
                variant="outlined"
                color="grey"
                @click="Adddialog = false"
                class="dialog-action-btn cancel-btn"
              >
                <v-icon class="mr-2">mdi-close</v-icon>
                {{ $t("close") }}
              </v-btn>

              <v-btn
                id="button-save-popupadd-setupgroupmodel"
                variant="elevated"
                @click="Save()"
                class="dialog-action-btn save-btn-add"
                :loading="dialog"
              >
                <v-icon class="mr-2">mdi-content-save</v-icon>
                {{ $t("save") }}
              </v-btn>
            </div>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Details -->
    <v-dialog v-model="Detaildialog" max-width="600px">
      <v-card class="detail-dialog">
        <!-- Dialog Header -->
        <v-card-title class="detail-header">
          <div class="detail-header-content">
            <div class="header-left">
              <v-icon size="28" color="white" class="mr-3 mt-4">mdi-robot-outline</v-icon>
              <div class="header-text">
                <h3 class="detail-title">{{ $t("modelName") }}</h3>
                <p class="detail-subtitle">Model details and information</p>
              </div>
            </div>
            <div class="header-right">
              <v-btn
                icon
                variant="text"
                @click="Detaildialog = false"
                class="detail-close-btn"
              >
                <v-icon color="white">mdi-close</v-icon>
              </v-btn>
            </div>
          </div>
        </v-card-title>

        <!-- Dialog Content -->
        <v-card-text class="detail-content">
          <div class="models-container">
            <!-- Empty State -->
            <div v-if="TempModel.length === 0" class="empty-state">
              <v-icon size="64" color="grey-lighten-2">mdi-robot-off</v-icon>
              <div class="text-h6 text-grey-darken-1 mt-4">No models found</div>
              <div class="text-body-2 text-grey">No model data available to display</div>
            </div>

            <!-- Model List -->
            <div v-else class="model-list">
              <div
                v-for="(item, index) in TempModel"
                :key="item.id"
                class="model-item"
                :class="{ 'last-item': index === TempModel.length - 1 }"
              >
                <div class="model-card">
                  <div class="model-content">
                    <div class="model-info">
                      <div class="model-icon-wrapper">
                        <v-icon size="24" color="primary">mdi-robot</v-icon>
                      </div>
                      <div class="model-details">
                        <h4 class="model-name">{{ item.name }}</h4>
                      </div>
                    </div>
                    
                    <div class="model-actions">
                      <v-btn
                        variant="outlined"
                        color="primary"
                        size="small"
                        class="view-btn"
                        @click="View(item)"
                      >
                        <v-icon size="16" class="mr-1">mdi-eye</v-icon>
                        View
                      </v-btn>
                    </div>
                  </div>
                </div>
                
                <!-- Divider (except for last item) -->
                <v-divider
                  v-if="index < TempModel.length - 1"
                  class="model-divider"
                ></v-divider>
              </div>
            </div>
          </div>
        </v-card-text>

        <!-- Dialog Actions -->
        <v-card-actions class="detail-actions">
          <div class="detail-actions-content">
            <div class="actions-left">
              <v-chip
                v-if="TempModel.length > 0"
                size="small"
                variant="tonal"
                color="info"
                class="summary-chip"
              >
                <v-icon size="14" class="mr-1">mdi-information</v-icon>
                {{ TempModel.length }} models
              </v-chip>
            </div>
            
            <div class="actions-right">
              <v-btn
                variant="outlined"
                color="grey"
                @click="Detaildialog = false"
                class="detail-action-btn close-action-btn"
              >
                <v-icon class="mr-2">mdi-close</v-icon>
                {{ $t("close") }}
              </v-btn>
            </div>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import checkPermissionTwo from "@/api/function.js";
import editImg from "@/assets/edit1.png";
import deleteImg from "@/assets/delete1.png";
import viewdetailImg from "@/assets/images/eyedetail.svg";
import editBtn from '@/assets/images/editbutton.png';
import deleteBtn from '@/assets/images/trashbutton.png';
import saveImg from '@/assets/images/savecard.png';
export default {
  name: "SetupGroupModel",
  inject: ["flagNav","FontColorTitle","SubNavbarBackGround"],
  mixins: [checkPermissionTwo],
  data: () => ({
    checkbox1: false,
    Editdialog: false,
    Adddialog: false,
    Detaildialog: false,
    dialog: false,
    valid: true,
    tempID: 0,
    MenuID1: null,
    MenuID2: null,
    MenuID3: null,
    menuID: null,
    subMenuID: null,
    today: null,
    maxLengthChar: 0,
    searchTotalTable: 0,
    totalTable: 0,
    itemsPerPage: 10,
    loadingTable: true,
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    rules: {
      required: (value) => !!value || "Required.",
    },
    DDGPTModel: [],
    headers_version_history: [],

    searchName: "",
    isSearch: false,
    isFirst: true,
    menus: [],
    images: {
      edit: editImg,
      delete: deleteImg,
      viewdetailImg: viewdetailImg,
      deleteBtn: deleteBtn,
      editBtn: editBtn,
      saveImg: saveImg,
    },
    GroupModel: {
      GroupID: null,
      Name: null,
      Model: null,
      NameModel: null,
      isAllModel: false,
    },
    TempModel: [],
    dialog_replace: false,
    replace_modelid: 0,
    replace_modelid_list: { id: 0, name: "x" },
    replace_modelid_lists: [], //{id:0, name: "x"}
    dialog_version: false,
    menus_version: [],
    menus_modeliddisplay_version: 0,
    searchTotalTable_version: 0,
    totalTable_version: 0,
    itemsPerPage_version: 5,
    sortBy: [],
    sortDesc: [],
  }),
  computed: {
    headers() {
      return [
        {
          title: this.$t("no"),
          align: "center",
          sortable: false,
          width: "95px",
        },
        {
          title: this.$t("Model Group"),
          align: "left",
          sortable: true,
          value: "Name",
        },
        {
          title: this.$t("modelName"),
          align: "left",
          sortable: false,
          value: "ModelNameTable",
        },
        { title: this.$t("manage"), align: "center", sortable: false, width: "150px" },
      ];
    },
  },
  watch: {
    options: {
      handler() {
        this.Get();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    getModelChips(modelNameTable) {
      if (!modelNameTable || modelNameTable === '' || modelNameTable === 'All Model') {
        return [];
      }

      return modelNameTable
        .split(', ')
        .map(item => {
          const name = item.split(':')[0].trim();
          return name;
        })
        .filter(name => name !== '');
    },
    clearModel() {
      let self = this;
      if (self.GroupModel.isAllModel) {
        self.GroupModel.Model = null;
      }
    },
    Search() {
      let self = this;
      self.dialog = true;
      self.isSearch = true;
      self.options.page = 1;
      self.GetDefault();
    },
    Get() {
      let self = this;
      // self.dialog = true;
      self.loadingTable = true;
      let { page, itemsPerPage, sortBy } = self.options;
      let sortField = null;
      let sortOrder = null;

      if (sortBy && sortBy.length > 0) {
        sortField = sortBy[0].key;
        sortOrder = sortBy[0].order === 'desc';
      }
      let temp = {
        page: self.isSearch ? 1 : page,
        perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
        name: self.searchName,
        sortDesc: sortOrder,
        sortBy: sortField,
      };
      self.$call.GetTableGroupModel(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.searchTotalTable = dataResponse.data.total;
            self.menus = dataResponse.data.data;
            self.totalTable = self.isFirst
              ? dataResponse.data.total
              : self.totalTable;
          } else {
            self.menus = [];
            self.searchTotalTable = 0;
            self.totalTable = 0;
          }
          self.GetDDGPTModel();
          // self.dialog = false;
          self.loadingTable = false;
          self.isSearch = false;
          self.isFirst = false;
        },
        (errorResource) => {
          self.loadingTable = false;
          // self.dialog = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    GetDefault() {
      let self = this;
      self.dialog = true;
      self.loadingTable = true;
      const { page, itemsPerPage } = self.options;
      let temp = {
        page: self.isSearch ? 1 : page,
        perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
        name: self.searchName,
        sortDesc: null,
        sortBy: null,
      };
      self.$call.GetTableGroupModel(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.searchTotalTable = dataResponse.data.total;
            self.menus = dataResponse.data.data;
            self.totalTable = self.isFirst
              ? dataResponse.data.total
              : self.totalTable;
          } else {
            self.menus = [];
            self.searchTotalTable = 0;
            self.totalTable = 0;
          }
          self.GetDDGPTModel();
          self.loadingTable = false;
          self.dialog = false;
          self.isSearch = false;
          self.isFirst = false;
        },
        (errorResource) => {
          self.loadingTable = false;
          self.dialog = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    GetDDGPTModel() {
      let self = this;
      self.loadingTable = true;
      self.$call.DDGPTModelIsPublish(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.DDGPTModel = dataResponse.data;
          } else {
            self.DDGPTModel = [];
          }
          self.loadingTable = false;
        },
        (errorResource) => {
          self.loadingTable = false;
          console.error(errorResource);
        }
      );
    },
    DeleteGroup(id) {
      let self = this;
      try {
        self.$swal
          .fire({
            title: this.$t("confirmDeletion"),
            text: this.$t("confirmDeletionModelGroup"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: this.$t("confirm"),
            cancelButtonText: this.$t("cancel"),
            reverseButtons: false,
          })
          .then((result) => {
            if (result.isConfirmed) {
              self.dialog = true;
              self.$call.DeleteGroupModel(
                id,
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    self.$swal.fire({
                      icon: "success",
                      title: dataResponse.message,
                      showConfirmButton: false,
                      timer: 1500,
                    });
                    self.Editdialog = false;
                    self.Get();
                  }
                  self.dialog = false;
                },
                (errorResource) => {
                  self.dialog = false;
                  self.Adddialog = false;
                  console.error(errorResource);
                }
              );
            }
          });
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },
    Add() {
      let self = this;
      self.GroupModel.GroupID = null;
      self.GroupModel.Name = null;
      self.GroupModel.Model = null;
      self.GroupModel.isAllModel = false;
      self.Adddialog = true;
    },
    Edit(item) {
      let self = this;
      self.Editdialog = true;
      self.GroupModel.GroupID = item.groupID;
      self.GroupModel.Name = item.name;
      self.GroupModel.Model = item.modelId;
      self.GroupModel.isAllModel = item.isAllModel;
    },
    Detail(item) {
      let self = this;
      self.TempModel = [];
      self.Detaildialog = true;
      self.GroupModel.GroupID = item.groupID;
      self.GroupModel.Name = item.name;
      self.GroupModel.Model = item.modelId;
      let dataLoop = item.modelName.split(", ");
      for (const element of dataLoop) {
        const name = element;
        const id = name.split(":")[1];
        let temp = {
          name: name.split(":")[0],
          id: id,
        };
        self.TempModel.push(temp);
      }
    },
    View(item) {
      let self = this;
      const routeData = self.$router.resolve({
        name: "GPTModelDetail",
        query: {
          id: item.id,
        },
      });
      window.open(routeData.href, "_blank");
    },
    Clear() {
      let self = this;
      self.GroupModel.GroupID = null;
      self.GroupModel.Name = null;
      self.GroupModel.Model = null;
      self.GroupModel.isAllModel = false;
      self.Editdialog = false;
      self.Adddialog = false;
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      this.today = dd + "/" + mm + "/" + yyyy;
    },
    substring(text) {
      if (text != null) {
        if (text.length > 50) {
          return text.substring(0, 50) + "...";
        }
        return text;
      }
      return text;
    },
    async Save() {
      let self = this;
      try {
        if (
          self.GroupModel.Name == "" ||
          self.GroupModel.Name == null ||
          ((self.GroupModel.Model == "" || self.GroupModel.Model == null) &&
            self.GroupModel.isAllModel == false)
        ) {
          self.$swal.fire({
            icon: "warning",
            title: self.$t("warning"),
            text: self.$t("warningFillAll"),
            showConfirmButton: false,
            timer: 1800,
          });
          return;
        }
        self.dialog = true;
        if (self.Adddialog) {
          await self.$call.CreateGroupModel(
            self.GroupModel,
            async (dataResponse) => {
              if (dataResponse.status == 0) {
                self.$swal.fire({
                  icon: "success",
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 1500,
                });
                self.totalTable = self.totalTable + 1;
                self.Get();
                self.Adddialog = false;
              } else if (dataResponse.status == 3) {
                self.$swal.fire({
                  icon: "warning",
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 2000,
                });
              }
              self.dialog = false;
            },
            (errorResource) => {
              self.dialog = false;
              self.Adddialog = false;
              console.error(errorResource);
            }
          );
        } else if (self.Editdialog) {
          await self.$call.UpdateGroupModel(
            self.GroupModel,
            async (dataResponse) => {
              if (dataResponse.status == 0) {
                self.$swal.fire({
                  icon: "success",
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 1500,
                });
                self.Get();
                self.Editdialog = false;
              } else if (dataResponse.status == 3) {
                self.$swal.fire({
                  icon: "warning",
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 2000,
                });
              }
              self.dialog = false;
            },
            (errorResource) => {
              self.dialog = false;
              self.Editdialog = false;
              console.error(errorResource);
            }
          );
        }
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },
  },
  mounted() {
    this.GetDate();
  },
};
</script>
<style scoped>
.card2 {
  border-radius: 10px !important;
  margin-bottom: 2rem;
  padding-top: 1rem;
}
.card {
  border-radius: 10px !important;
  height: 90vh;
  overflow: auto;
  margin: 0;
  padding: 0;
}
textarea {
  min-height: 800px !important;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}

:deep(.v-data-table tbody tr) {
  transition: all 0.2s ease;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

:deep(.v-data-table tbody tr:hover) {
  background: rgba(0, 0, 0, 0.02);
  /* transform: translateY(-1px); */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

:deep(.v-data-table-header) {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 2px solid #dee2e6;
}

:deep(.v-data-table-header th) {
  color: #495057 !important;
  font-weight: 700 !important;
  font-size: 0.875rem !important;
  padding: 1rem !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid rgba(25, 118, 210, 0.1) !important;
}

/*#region Details Dialog*/

/* Dialog Base Styles */
/* .modern-dialog, */
.detail-dialog {
  border-radius: 20px !important;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15) !important;
  max-height: 90vh;
}

.detail-dialog {
  max-height: 85vh;
}

/* Dialog Headers */
/* .dialog-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 24px !important;
  border-bottom: none;
} */

.detail-header {
  background: linear-gradient(135deg, #4a90e2 0%, #357abd 100%);
  color: white;
  padding: 24px !important;
  border-bottom: none;
}

/* .header-content, */
.detail-header-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
}

.header-left {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

/* .header-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
} */

/* .dialog-title {
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0;
  color: white;
  letter-spacing: 0.025em;
} */

.detail-title {
  font-size: 1.4rem;
  font-weight: 700;
  margin: 0;
  color: white;
  letter-spacing: 0.025em;
}

.dialog-subtitle,
.detail-subtitle {
  font-size: 0.9rem;
  margin: 0;
  color: rgba(255, 255, 255, 0.8);
  font-weight: 400;
}

.detail-subtitle {
  font-size: 0.85rem;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.close-btn,
.detail-close-btn {
  background: rgba(255, 255, 255, 0.1) !important;
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
}

.close-btn:hover,
.detail-close-btn:hover {
  background: rgba(255, 255, 255, 0.2) !important;
  transform: scale(1.05);
}

.count-chip {
  background: rgba(255, 255, 255, 0.2) !important;
  color: white !important;
  font-weight: 600;
  backdrop-filter: blur(10px);
}

/* Dialog Content */
.dialog-content {
  padding: 32px 24px !important;
  background: #fafafa;
  max-height: 60vh;
  overflow-y: auto;
}

.detail-content {
  padding: 0 !important;
  background: #fafafa;
  max-height: 50vh;
  overflow-y: auto;
}

.models-container {
  padding: 24px;
}

/* Model List and Cards */
.model-list {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.model-item {
  position: relative;
}

.model-card {
  background: white;
  border-radius: 16px;
  padding: 20px;
  transition: all 0.3s ease;
  border: 2px solid transparent;
  position: relative;
  overflow: hidden;
  width: 100%;
}

.model-card:hover {
  border-color: rgba(74, 144, 226, 0.2);
  box-shadow: 0 8px 25px rgba(74, 144, 226, 0.15);
  transform: translateY(-2px);
}

.model-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 16px;
}

.model-info {
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
  min-width: 0;
}

.model-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background: rgba(74, 144, 226, 0.1);
  border-radius: 12px;
  border: 2px solid rgba(74, 144, 226, 0.2);
  flex-shrink: 0;
}

.model-details {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.model-name {
  font-size: 1.1rem;
  font-weight: 600;
  color: #2c3e50;
  margin: 0;
  letter-spacing: 0.025em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.2;
}

.model-actions {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
  align-items: center;
}

.view-btn {
  border-radius: 10px !important;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.025em;
  transition: all 0.3s ease;
  min-width: 80px;
  height: 36px;
  white-space: nowrap;
}

.view-btn:hover {
  background: #4a90e2 !important;
  color: white !important;
  border-color: #4a90e2 !important;
  transform: scale(1.05);
}

.model-divider {
  margin: 10px 0;
  border-color: rgba(74, 144, 226, 0.9);
}
/* Dialog Actions */
/* .dialog-actions, */
.detail-actions {
  padding: 20px 24px !important;
  background: white;
  border-top: 1px solid #e9ecef;
}

/* .actions-content, */
.detail-actions-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.actions-left {
  display: flex;
  align-items: center;
}

.actions-right {
  display: flex;
  gap: 12px;
}

/* Buttons */
/* .dialog-action-btn {
  height: 44px;
  border-radius: 12px !important;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.025em;
  transition: all 0.3s ease;
  min-width: 120px;
} */

.detail-action-btn {
  height: 40px;
  border-radius: 12px !important;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.025em;
  transition: all 0.3s ease;
  min-width: 100px;
}

/* .cancel-btn, */
.close-action-btn {
  border: 2px solid #dee2e6 !important;
  color: #6c757d !important;
}

/* .cancel-btn:hover, */
.close-action-btn:hover {
  border-color: #adb5bd !important;
  background: #f8f9fa !important;
  transform: translateY(-1px);
}

/* Scrollbar Styling */
.dialog-content::-webkit-scrollbar,
.detail-content::-webkit-scrollbar {
  width: 6px;
}

.dialog-content::-webkit-scrollbar-track,
.detail-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.dialog-content::-webkit-scrollbar-thumb,
.detail-content::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.dialog-content::-webkit-scrollbar-thumb:hover,
.detail-content::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Animations */
@media (prefers-reduced-motion: no-preference) {
  /* .modern-dialog, */
  .detail-dialog {
    animation: dialogSlideIn 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  }
  
  @keyframes dialogSlideIn {
    from {
      opacity: 0;
      transform: translateY(-30px) scale(0.95);
    }
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }
  
  .model-card {
    animation: modelCardFadeIn 0.3s ease forwards;
  }
  
  @keyframes modelCardFadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
}
/*#endregion Details Dialog*/


.modern-autocomplete :deep(.v-field) {
  border-radius: 12px;
  transition: all 0.3s ease;
}

.modern-autocomplete :deep(.v-field:hover) {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.modern-autocomplete :deep(.v-field--focused) {
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.2);
}
/* Modern Dialog Styles */
/* .modern-dialog {
  border-radius: 20px !important;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15) !important;
} */

/* Dialog Header */
/* .dialog-header {
  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
  color: white;
  padding: 24px !important;
  border-bottom: none;
} */

/* .edit-header {
  background: linear-gradient(135deg, #f57c00 0%, #ef6c00 100%);
} */

/* .header-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
} */

.header-left {
  display: flex;
  align-items: flex-start;
  gap: 16px;
}

/* .header-icon {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
} */

/* .header-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.dialog-title {
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0;
  color: white;
  letter-spacing: 0.025em;
}

.dialog-subtitle {
  font-size: 0.9rem;
  margin: 0;
  color: rgba(255, 255, 255, 0.8);
  font-weight: 400;
} */

.header-right {
  display: flex;
  align-items: center;
}

.close-btn {
  background: rgba(255, 255, 255, 0.1) !important;
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
}

.close-btn:hover {
  background: rgba(255, 255, 255, 0.2) !important;
  transform: scale(1.05);
}

/* Dialog Content */
.dialog-content {
  padding: 32px !important;
  background: #fafafa;
}

.form-container {
  background: white;
  border-radius: 16px;
  padding: 24px;
  border: 1px solid rgba(0, 0, 0, 0.08);
}

.form-section {
  margin-bottom: 32px;
}

.form-section:last-child {
  margin-bottom: 0;
}

.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid rgba(25, 118, 210, 0.1);
}

.section-title {
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0;
  color: #1976d2;
  letter-spacing: 0.025em;
}

/* Input Styling */
.input-wrapper {
  margin-bottom: 20px;
  transition: all 0.3s ease;
}

.input-wrapper.disabled-section {
  opacity: 0.6;
  pointer-events: none;
}

.input-label {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  font-weight: 600;
  color: #424242;
  font-size: 0.9rem;
  gap: 4px;
}

.required-asterisk {
  color: #d32f2f;
  font-weight: 700;
}

.help-icon {
  cursor: help;
  transition: all 0.2s ease;
  opacity: 0.7;
}

.help-icon:hover {
  opacity: 1;
  color: #1976d2 !important;
  transform: scale(1.1);
}

.modern-input :deep(.v-field) {
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;
}

.modern-input :deep(.v-field:hover) {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.modern-input :deep(.v-field--focused) {
  box-shadow: 0 4px 16px rgba(25, 118, 210, 0.2);
}

/* Checkbox Styling */
.checkbox-wrapper {
  margin-bottom: 20px;
  padding: 16px;
  background: rgba(25, 118, 210, 0.04);
  border-radius: 12px;
  border: 1px solid rgba(25, 118, 210, 0.1);
}

.checkbox-label {
  display: flex;
  align-items: center;
  font-weight: 500;
  color: #424242;
}

.modern-checkbox :deep(.v-selection-control__input) {
  border-radius: 6px;
}

/* Autocomplete Styling */
.modern-autocomplete :deep(.v-field) {
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;
}

.modern-autocomplete :deep(.v-field:hover) {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.modern-autocomplete :deep(.v-field--focused) {
  box-shadow: 0 4px 16px rgba(25, 118, 210, 0.2);
}

.model-chip {
  margin: 2px 4px 2px 0 !important;
  font-weight: 500 !important;
}

.autocomplete-item:hover {
  background: rgba(25, 118, 210, 0.04) !important;
}

/* Info Message */
.info-message {
  display: flex;
  align-items: center;
  margin-top: 16px;
  padding: 12px 16px;
  background: rgba(33, 150, 243, 0.08);
  border-radius: 8px;
  border-left: 4px solid #2196f3;
  font-size: 0.875rem;
  color: #1565c0;
}

/* Dialog Actions */
/* .dialog-actions {
  padding: 24px 32px !important;
  background: white;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
} */

/* .actions-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
} */

/* .actions-left {
  display: flex;
  align-items: center;
}

.actions-right {
  display: flex;
  gap: 12px;
}
*/
/* .dialog-action-btn {
  height: 44px;
  border-radius: 12px !important;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.025em;
  transition: all 0.3s ease;
  min-width: 120px;
} */
/*
.cancel-btn {
  color: #757575 !important;
  border-color: #e0e0e0 !important;
}

.cancel-btn:hover {
  background: rgba(117, 117, 117, 0.04) !important;
  border-color: #bdbdbd !important;
  transform: translateY(-1px);
}

.save-btn {
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.3) !important;
}

.save-btn:hover {
  box-shadow: 0 6px 16px rgba(25, 118, 210, 0.4) !important;
  transform: translateY(-1px);
} */

.summary-chip {
  background: rgba(33, 150, 243, 0.1) !important;
  color: #1565c0 !important;
  font-weight: 600;
}

/* Responsive */
@media (max-width: 600px) {
  /* .dialog-header {
    padding: 20px 24px !important;
  } */
  
  .dialog-content {
    padding: 24px !important;
  }
  
  .form-container {
    padding: 20px;
  }
  
  .dialog-actions {
    padding: 20px 24px !important;
    flex-direction: column-reverse;
    gap: 16px;
  }
  
  .actions-content {
    flex-direction: column-reverse;
    gap: 16px;
    width: 100%;
  }
  
  .actions-right {
    width: 100%;
    flex-direction: column;
  }
  
  .dialog-action-btn {
    width: 100%;
  }
}
.customadd{
  min-width: 100px!important;
  height: 40px!important;
  justify-content: center;
  align-items: center;
}
:deep(thead) {
  background-color: #FFE4E1 !important;
}
.v-table--has-top :deep(.v-table__wrapper) {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-center .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 15px;
}
:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-left .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 15px;
}
:deep(.v-pagination__first),
:deep(.v-pagination__last) {
  display: none !important;
}

:deep(.v-pagination__list) {
  gap: 4px;
}
:deep(.v-data-table-footer .v-field) {
  border-radius: 10px !important;
  width: 70px !important;
}
.model-chip-item{
  border-radius: 24px;
  border: 1px solid rgba(195, 46, 14, 0.25);
  background: rgba(195, 46, 14, 0.10);
  color: #C32E0E;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  margin-left: 10px;
}
.model-chip-count{
  width: 33px;
  height: 33px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  border-radius: 24px;
  background: #C32E0E;
  margin-left: 10px;
  color: white;
}
</style>
